import React from 'react';
import { Card, Col, Row } from 'reactstrap';
import AuthForm, { STATE_LOGIN } from '../components/AuthForm';
import { useNavigate } from 'react-router-dom';

const AuthPage = ({ authState }) => {
  const navigate = useNavigate();

  const handleAuthState = authState => {
    if (authState === STATE_LOGIN) {
      navigate('/login');
    } else {
      navigate('/signup');
    }
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <Row
      style={{
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#102E50',
      }}
    >
      <Col md={6} lg={4}>
        <Card body style={{ borderRadius: '20px' }}>
          <AuthForm
            authState={authState}
            onChangeAuthState={handleAuthState}
            onLogoClick={handleLogoClick}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default AuthPage;
